// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__mPZHU","noTitle":"checkbox_noTitle__S-uMc","checkmark":"checkbox_checkmark__yFB64","noTitleCheckmark":"checkbox_noTitleCheckmark__F5iFF"};